import React from "react";
import "./LoadingOverlay.css";

function LoadingOverlay({ isVisible, text }) {
  return (
    <div className={`loading-overlay ${isVisible ? "" : "hidden"}`}>
      <div className="spinner"></div>
      <div className="loading-text">{text || "Analyzing Map Data..."}</div>
    </div>
  );
}

export default LoadingOverlay;
